<template>
<div style="position:relative;">
    <div class="nodata_chart" ref="nodata" :style="{color:'rgba(0, 0, 0, 0.45)', background:'#fbfbfb', height:`${height}px`, lineHeight:`${height}px`, textAlign:'center'}"  v-if="datas.length<=0 || change || waiting">
        {{$t("common.noData")}}
    </div>
    <div v-if="conf.type!='violin' && datas.length>0" :style="{width:chart.width?`${chart.width}px`:'auto', margin:'0 auto'}">
    <!-- html legend -->
    <div :id="`chart_legend_${uuid}`" class="chart_legend" v-if="!waiting && !change&&(conf.type!='violin' && conf.type!='treemap' && (conf.legend!=false && conf.htmllegend==true))"></div>
    
    <div v-if="!waiting && !change&&conf.type!='violin' && conf.type!='treemap' && conf.legend!=false && series.length > 2" id="chart_legend_control">
        <a-select
            size="small"
            v-model="sorter"
            :dropdownMatchSelectWidth="false"
            v-if="series && conf.series && conf.series.sort"
            placeholder="默认排序"
            class="chart_trans_select" 
            @change="sorter_change"
        >
            <a-select-option key="default-sorter" size="small">默认排序</a-select-option>
            <a-select-option v-for="series in series_options" :key="`${series.key}`" size="small">
                {{series.label}}
            </a-select-option>
        </a-select>
        <a-button @click="handleLegend(true)" size="small"><a-icon type="line" />{{$t("chart.hideAllLegend")}}</a-button>
        <a-button @click="handleLegend(false)" size="small"><a-icon type="menu" />{{$t("chart.showAllLegend")}}</a-button>
    </div>
    <v-chart :id="`chart${uuid}`" :force-fit="chart.width?false:true" :width="chart.width" :height="chart.height" :data="data" :scale="chart.scale" :filter="chart.filter" :padding="conf.type=='pie'?50:'auto'" v-if="datas.length>0 && !change && !waiting"> 
        <!---------------------------------------- 绘图开始 ------------------------------------------->
        <!-- 普通图 -->
        <v-series v-if="['pie', 'pyramid', 'box', 'candle', 'heatmap', 'worldmap', 'chinamap', 'cloud', 'mixin', 'treemap', 'polygon'].indexOf(conf.type) < 0"
            :quickType="chart.type" 
            :position="`${conf.x.id}*${conf.y.id}`" 
            :color="conf.other && conf.other.color?conf.other.color:conf.series?(conf.color?[conf.series.id,conf.color]:conf.series.id):(conf.color?conf.color:null)"
            :label="conf.label?chart.label:null" 
            :shape="conf.shape?conf.shape:(chart.type=='smoothLine'?'smooth':null)"
            :tooltip="chart.tooltip" :active="false"
            :size="conf.other && conf.other.size?conf.other.size:null"
            :adjust="conf.other && conf.other.adjust?conf.other.adjust:chart.type.startsWith('stack')?'stack':chart.type.startsWith('dodge')?'dodge':null"
        />

        <!-- 折线图绘制点 -->
        <v-series v-if="['line', 'spline', 'area'].indexOf(conf.type) >= 0 && (conf.point!=false || xLength==1) && conf.online!=true" 
            quickType="point" :shape="conf.versionday?'versionPoint':'circle'" 
            :position="`${conf.x.id}*${conf.y.id}`" 
            :color="conf.other && conf.other.color?conf.other.color:conf.series?(conf.color?[conf.series.id,conf.color]:conf.series.id):(conf.color?conf.color:null)" 
            :adjust="chart.type=='stackArea'?'stack':null"
            :tooltip="chart.tooltip" :active="false"
        />

        <!-- 面积图绘制线 -->
        <v-series v-if="['area'].indexOf(conf.type) >= 0" 
            quickType="line" :tooltip="false"
            :position="`${conf.x.id}*${conf.y.id}`" 
            :color="conf.series?(conf.color?[conf.series.id,conf.color]:conf.series.id):(conf.color?conf.color:null)" 
            :adjust="chart.type=='stackArea'?'stack':null"/>

        <!-- 雷达图 -->
        <v-coord v-if="conf.type=='polar'" type="polar" />
        
        <!-- 饼图 -->
        <v-series v-if="conf.type=='pie'" 
            :quickType="chart.type" :position="chart.empty?`fake_${conf.y.id}`:conf.y.id" :color="conf.color?[conf.x.id,conf.color]:conf.x.id"
            :label="conf.label?chart.label:null" 
            :tooltip="chart.tooltip"
        />
        <v-coord v-if="conf.type=='pie'" type="theta" :innerRadius="conf.other&&conf.other.innerRadius?conf.other.innerRadius:0"/>
        
        <!-- 漏斗图 -->
        <v-series v-if="conf.type=='pyramid'" 
            :quickType="chart.type" :position="`${conf.x.id}*${conf.y.id}`" :color="conf.color?[conf.x.id,conf.color]:conf.x.id"
            :label="conf.label?chart.label:null" 
            :tooltip="chart.tooltip"
        />
        <v-coord v-if="conf.type=='pyramid'" type="rect" direction="LT" />

        <!-- 箱型图 -->
        <v-series v-if="conf.type=='box'" 
            :quickType="chart.type" :position="`${conf.x.id}*range`" :color="conf.series?(conf.color?[conf.series.id,conf.color]:conf.series.id):(conf.color?conf.color:null)" adjust="dodge"
            :tooltip="chart.tooltip"
        />

        <!-- 烛型图 -->
        <v-series v-if="conf.type=='candle'" 
            :quickType="chart.type" :position="`${conf.x.id}*range`" :color="['trend', val => val === '上涨'?'#f04864':'#2fc25b']" 
            :tooltip="chart.tooltip"
        />

        <!-- 热力图 -->
        <v-point v-if="conf.type=='heatmap' && heatmap.point" :position="`${conf.x.id}*${conf.y.id}`" :color="[conf.series.id, '#F51D27-#FA541C-#FF8C12-#FFC838-#FAFFA8-#80FF73-#12CCCC-#1890FF-#6E32C2']"  
            :size="3" :opacity="0.65"  shape="circle" :tooltip="chart.tooltip"/>

        <v-series v-if="conf.type=='heatmap' && heatmap.heat" 
            :quickType="chart.type" :position="`${conf.x.id}*${conf.y.id}`" :opacity="0"  :color="[conf.series.id, '#F51D27-#FA541C-#FF8C12-#FFC838-#FAFFA8-#80FF73-#12CCCC-#1890FF-#6E32C2']" 
            :tooltip="chart.tooltip"
        />
    
        <v-guide v-if="conf.type=='heatmap'"
            type="image" :start="['min', 'max']" :end="['max', 'min']" :src="conf.src" />
        
        <!-- 地图 -->
        <v-view v-if="conf.type=='worldmap' || conf.type=='chinamap'" :start="{x:conf.type=='chinamap'?0.1:0,y:0}" :end="{x:0.6, y:1}"
            :data="conf.type=='chinamap'?chinaGeoData:worldGeoData" :scale="chart.scale">
            <v-polygon position="longitude*latitude" :tooltip="false" :vStyle="{fill: '#DDDDDD', stroke: '#b1b1b1', lineWidth: 0.5, fillOpacity: 1}"/>
        </v-view>
        
        <v-view v-if="conf.type=='worldmap' || conf.type=='chinamap'" :start="{x:conf.type=='chinamap'?0.1:0,y:0}" :end="{x:0.6, y:1}"
            :data="data" :scale="[{dataKey:'value', alias: $t('common.value') }]">
            <v-polygon position="longitude*latitude" :color="['value', conf.color?conf.color:'#e6f7ff-#bae7ff-#91d5ff-#69c0ff-#40a9ff-#1890ff-#096dd9-#0050b3-#003a8c-#002766']"
            :tooltip="chart.tooltip"/>
        </v-view>
        
        <v-view v-if="conf.type=='worldmap' || conf.type=='chinamap'"  :start="{x:0.7, y:0}" :end="{x:0.9, y:1}" style="width:50%; float:right;"
            :data="$_.take(data, 10)" :scale="[{dataKey:'value', alias: $t('common.value') }]">
            <v-series quickType="bar" position="name*value" label="value" :color="['value', conf.color?conf.color:'#e6f7ff-#bae7ff-#91d5ff-#69c0ff-#40a9ff-#1890ff-#096dd9-#0050b3-#003a8c-#002766']"/>
            <v-coord type="rect" direction="RB" />
            <v-axis dataKey="name" position="left" :grid="null"/>
            <v-axis dataKey="value" :show="false"/>
        </v-view>

        <!-- 词云 -->
        <v-coord v-if="conf.type=='cloud'" type="rect" direction="TL" />
        <v-point v-if="conf.type=='cloud'" position="x*y" :color="conf.x.id" shape="cloud" :tooltip="conf.x.id*conf.y.id" />

        <!-- Treemap图 -->
        <v-series v-if="conf.type=='treemap'" 
            :quickType="chart.type" position="x*y" :color="conf.color?['name',conf.color]:'name'" :label="['name', {offset: 0, textStyle: {textBaseline: 'middle', fill:'#fff'}, formatter(val) {if (val !== 'root') {return val;}},}]"
            :tooltip="chart.tooltip" :vStyle="{lineWidth: 1,stroke: '#fff',}" padding="0"
        />
        
        <!-- 混合图 -->
        <v-view v-if="conf.type=='mixin'&&chart.type.left" :data="data[0]" :scale="chart.scale" :filter="chart.filter">
            <v-series 
                :quickType="chart.type.left" position="x*y" :color="conf.yaxis&&conf.yaxis.left&&conf.yaxis.left.color?['series',conf.yaxis.left.color]:'series'"
                :label="conf.label && chart.label && chart.label.length > 0?chart.label[0]:null" 
                :shape="conf.yaxis&&conf.yaxis.left&&conf.yaxis.left.shape?conf.yaxis.left.shape:(chart.type.left=='smoothLine'?'smooth':null)"  :tooltip="chart.tooltip[0]"/>

            <!-- <v-series 
                :quickType="chart.type.left" position="x*y" 
                :label="conf.label?'y':null" 
                :shape="conf.yaxis&&conf.yaxis.left&&conf.yaxis.left.shape?conf.yaxis.left.shape:null"  :tooltip="chart.tooltip[0]"/> -->

            <!-- 折线图绘制点 -->
            <v-series v-if="['line', 'smoothLine', 'area', 'stackArea'].indexOf(chart.type.left) >= 0 && (conf.yaxis.left.point!=false || xLength==1)" 
                :shape="conf.versionday?'versionPoint':'circle'"
                quickType="point" position="x*y" :color="conf.yaxis&&conf.yaxis.left&&conf.yaxis.left.color?['series',conf.yaxis.left.color]:'series'" :adjust="chart.type.left=='stackArea'?'stack':null" />

            
            <!-- 面积图绘制线 -->
            <v-series  v-if="['area', 'stackArea'].indexOf(chart.type.left) >= 0" 
                quickType="line" position="x*y" :tooltip="false"
                :color="conf.yaxis&&conf.yaxis.left&&conf.yaxis.left.color?['series',conf.yaxis.left.color]:'series'" 
                :adjust="chart.type.left=='stackArea'?'stack':null"/>
            
            <!-- 增加标注 -->
            <template >
                <v-guide :type="guide.type" v-for="(guide, index) in marker_guides" :key="`marker_guide_${index}`" :zIndex="0"
                    :start="guide.start" :end="guide.end" :position="guide.position" 
                    :vStyle="guide.vStyle" :lineStyle="guide.lineStyle" 
                    :html="guide.html" 
                />
            </template>
        </v-view>
        <v-view v-if="conf.type=='mixin'&&chart.type.right" :data="data[1]" :scale="chart.scale" :filter="chart.filter">
            <v-series 
                :quickType="chart.type.right" position="x*r" :color="conf.yaxis&&conf.yaxis.right&&conf.yaxis.right.color?['series',conf.yaxis.right.color]:'series'"
                :label="conf.label && chart.label && chart.label.length > 1?chart.label[1]:null" :vStyle="conf.yaxis&&conf.yaxis.right&&conf.yaxis.right.style?conf.yaxis.right.style:null"
                :shape="conf.yaxis&&conf.yaxis.right&&conf.yaxis.right.shape?conf.yaxis.right.shape:(chart.type.right=='smoothLine'?'smooth':null)" :tooltip="chart.tooltip[1]"/>
                
            <!-- 折线图绘制点 -->
            <v-series v-if="['line', 'smoothLine', 'area', 'stackArea'].indexOf(chart.type.right) >= 0 && (!(conf.yaxis.right.other && conf.yaxis.right.other.point==false) || xLength==1)"  
                :shape="conf.versionday?'versionPoint':'circle'"
                quickType="point" position="x*r" :color="conf.yaxis&&conf.yaxis.right&&conf.yaxis.right.color?['series',conf.yaxis.right.color]:'series'" :adjust="chart.type.right=='stackArea'?'stack':null" />

            
            <!-- 面积图绘制线 -->
            <v-series  v-if="['area', 'stackArea'].indexOf(chart.type.right) >= 0" 
                quickType="line" position="x*r" :tooltip="false"
                :color="conf.yaxis&&conf.yaxis.right&&conf.yaxis.right.color?['series',conf.yaxis.right.color]:'series'" 
                :adjust="chart.type.right=='stackArea'?'stack':null"/>
        </v-view>
        <!-- 多边形图 -->
        <v-view v-if="conf.type=='polygon'" >
            <v-series :quickType="chart.type" :position="`${conf.x.id}*${conf.y.id}`" :color="[conf.series.id||conf.x.id, conf.color||'#F51D27-#FA541C-#FF8C12-#FFC838-#FAFFA8-#80FF73-#12CCCC-#1890FF-#6E32C2']" :tooltip="chart.tooltip" />
            <v-axis :dataKey="conf.x.id" :title="{ text: `${conf.x.title}` }" :tickLine="null"
                :grid="{ align: 'center', lineStyle: { lineWidth: 1, lineDash: null, stroke: '#f0f0f0' } }" />
            <v-axis :dataKey="conf.y.id" :title="{ text: `${conf.y.title}` }" :tickLine="null" 
                :grid="{ align: 'center', lineStyle: { lineWidth: 1, lineDash: null, stroke: '#f0f0f0' } }" />            
        </v-view>
        
        <!---------------------------------------- 绘图结束 ------------------------------------------->
            
        <!-- 坐标轴 -->
        <v-axis v-for="(axis, index) in chart.axis" :key="index"
            :dataKey="axis.dataKey" :title="{textStyle:{fontSize:0}}" :position="axis.position" 
            :label="axis.label" :grid="axis.grid" :tick="axis.tick"
            :line="{lineWidth:1}" :tickLine="{length:5}"/>
        
        <!-- 提示 -->
        <v-tooltip v-if="['pie', 'pyramid', 'box', 'candle', 'heatmap', 'worldmap', 'chinamap', 'treemap', 'mixin', 'cloud', 'polygon'].indexOf(conf.type)<0 && conf.tooltip!=false"
            :showTitle="(conf.fixed===true && conf.x && conf.x.id=='ds')?false:true" :crosshairs="conf.other && conf.other.tooltip && conf.other.tooltip.crosshairs?conf.other.tooltip.crosshairs:{style:{lineDash:[3]}}" :hideMarkers="conf.versionday?true:false"
            :onChange="handleTooltipChange"
        />
        <v-tooltip v-if="['pie', 'pyramid', 'box', 'candle', 'heatmap', 'worldmap', 'chinamap', 'treemap', 'cloud', 'polygon'].indexOf(conf.type)>=0"
            :showTitle="['pie', 'pyramid', 'candle', 'heatmap', 'worldmap', 'chinamap','treemap', 'cloud', 'polygon'].indexOf(conf.type)>=0?false:conf.series?true:false"  :hideMarkers="conf.versionday?true:false"
            itemTpl='<li data-index={index}><span style="background-color:{color};" class="g2-tooltip-marker"></span>{name} {value}</li>' />
        
        <v-tooltip v-if="conf.type=='mixin' && !conf.htmlContent" :showTitle="true" :crosshairs="conf.other && conf.other.tooltip && conf.other.tooltip.crosshairs?conf.other.tooltip.crosshairs:{style:{lineDash:[3]}}" :hideMarkers="conf.versionday?true:false" :inPlot="false"
            itemTpl='<li data-index={index}><span style="background-color:{color};" class="g2-tooltip-marker"></span>{name}<span style="float:right;margin:0 0 0 20px">{value}</span></li>' />
        <v-tooltip v-if="conf.type=='mixin' && conf.htmlContent" :htmlContent="conf.htmlContent" />

        <!-- html 图例 -->
        <v-legend v-if="['violin', 'treemap', 'cloud'].indexOf(conf.type) < 0 && (conf.legend!=false && conf.htmllegend==true)"
        :allowAllCanceled="true" :useHtml="true" marker='square'
        :itemTpl="legendTemplate" :clickable="legend_click"
        :container="`chart_legend_${uuid}`" />

        <!-- 普通 图例 -->
        <v-legend v-if="['violin', 'treemap', 'cloud'].indexOf(conf.type) < 0 && (conf.legend!=false && conf.htmllegend!=true)" :allowAllCanceled="true" 
            :position="conf.other&&conf.other.legend&&conf.other.legend&&conf.other.legend.position?conf.other.legend.position:'top-center'"
            :offsetY="!(conf.fixed===true || conf.home===true)?-20:marker_guides.length==0?0:-20" :clickable="legend_click" :reversed="conf.other&&conf.other.legend?conf.other.legend.reversed:false"/>
        
        <!-- <v-legend v-if="conf.legend!=false && conf.compare==true && conf.type!='treemap'"  :allowAllCanceled="true"
            itemTpl= '<li class="g2-legend-list-item item-{index} {checked}" data-color="{originColor}" data-value="{originValue}" style="cursor: pointer;font-size: 14px;"><i class="g2-legend-marker" style="width:10px;height:10px;border-radius:50%;display:inline-block;margin-right:10px;background-color: {color};"></i><span class="g2-legend-text">{value}</span></li>'
            :position="conf.other&&conf.other.legend&&conf.other.legend&&conf.other.legend.position?conf.other.legend.position:'top-center'" :useHtml="true" :flipPage="true" container="chart_legend"/>
            -->
        <template v-for="(axis, index) in chart.axis" >
            <v-guide  v-if="axis.position=='left' || axis.position=='right'" :key="`guide_axis_${index}`"
            type="text"  :position="axis.position=='left'?['0%', '0%']:['100%', '0%']" 
            :offsetY="conf.label?-40:-20" :offsetX="0" :content="axis.title.text" zIndex="8" :vStyle="{fill:'#bbb', fontWeight:'normal', textAlign:axis.position=='left'?'end':'start'}"/>
        </template>

        <template v-for="(guide, index) in guides">
            <v-guide  v-if="guide.type=='text'" :key="`guide_${index}`"
                type="text"  :position="[guide.x, guide.y]"  :content="guide.text" :offsetX="10" 
                :vStyle="{fill:'#999', fontWeight:'normal'}"
            />
            <v-guide  v-if="guide.type=='html'" :key="`guide_${index}`"
                type="html"  :position="[guide.x, guide.y]"  :html="guide.html" 
            />
            <v-guide  v-if="guide.type=='dataMarker'" :key="`guide_${index}`"
                type="dataMarker"  :position="[guide.x, guide.y]"  :content="guide.content" :direction="guide.direction" :vStyle="guide.style" :display="guide.display" :lineLength="15"
            />
        </template>

        <!-- 增加标注 -->
        <template v-if="conf.type!='mixin'">
            <v-guide :type="guide.type" v-for="(guide, index) in marker_guides" :key="`marker_guide_${index}`"  :zIndex="0"
                :start="guide.start" :end="guide.end" :position="guide.position" 
                :vStyle="guide.vStyle" :lineStyle="guide.lineStyle" 
                :html="guide.html" 
            />
        </template>
        <v-guide v-if="conf.fixed==true && conf.x && (conf.x.id=='ds' || conf.x.id=='weekname')" type="html" :position="['',0]" html="<div style='width:50px;height:50px; background:#fff;'></div>" zIndex="8"/>
        
    </v-chart>
    <template v-for="(axis, index) in chart.axis" >
        <div v-if="axis.position=='bottom' && datas.length>0" style="width:100%; text-align:center; color:#bbb; font-size:12px; margin:-20px 0 10px 0" :key="`guide_axis_${index}`">{{axis.title}}</div>
    </template>
    <v-plugin v-if="datas.length>0">
    <v-slider v-if="conf.slider" :container="`slider${uuid}`" :padding="[20, 200, 20, 200]"
        :data="conf.type!='mixin'?chart.data:chart.data[0]" :xAxis="conf.type!='mixin'?conf.x.id:'x'" :yAxis="conf.type!='mixin'?conf.y.id:'y'" :start="slider.start" :end="slider.end" 
        :onChange="changeSlider"/>
    </v-plugin>
    <div v-if="conf.legend!=false && conf.compare==true" id="chart_legend"></div>
    <div v-if="conf.type=='heatmap'" style="text-align:center">
        <a-checkbox :checked="heatmap.point" @change="changeHeatmap($event, 'point')">显示点层</a-checkbox>
        <a-checkbox :checked="heatmap.heat" @change="changeHeatmap($event, 'heat')">显示热力层</a-checkbox>
    </div>
    </div>
    
    <div v-if="conf.type=='violin' && datas.length>0">
        <Violin :uuid="uuid" :conf="conf" :fields="fields" :datas="datas" :height="height"/>
    </div>
</div>
</template>

<script>
import {weekday} from '@/utils/utils'
import {isDate} from '@/utils/datetime'
import moment from "moment"
import { ChinaCityLang, worldNamesDict } from '@/constants/geoMap';

import Vue from 'vue'
import Viser from 'viser-vue'
import { registerShape, Global } from 'viser-vue';
var Violin =() => import('@/components/common/chart/violin.vue')

import {initType, initScale, initAxis, initData, initTooltip, initLabel, initColor, initFilter, initUdColor, DefaultTheme} from '@/utils/chart'
Vue.use(Viser)
Global.registerTheme('DefaultTheme', DefaultTheme)
Global.setTheme('DefaultTheme')

registerShape('point', 'cloud', {
  draw(cfg, container) {
    return container.addShape('text', {
      attrs: {
        fillOpacity: cfg.opacity,
        fontSize: cfg.origin._origin.size,
        rotate: cfg.origin._origin.rotate,
        text: cfg.origin._origin.text,
        textAlign: 'center',
        //fontFamily: cfg.origin._origin.font,
        fill: cfg.color,
        textBaseline: 'Alphabetic',
        x: cfg.x,
        y: cfg.y,
      },
    });
  }
});

registerShape('line', 'splitLine', {
  draw(cfg, container) {
    var color = cfg.points[0].color;
    var path1 = [], path2 = [];
    var path3 = []
    var yesterday = moment().subtract(1, 'day').format('YYYY-MM-DD')
    for (var i = 0; i < cfg.points.length; i++) {
        if(cfg.points[i]._origin.series_visible===false) {
            continue
        }
        if(cfg.points[i]._origin.dt == yesterday) {
            if(path2.length==0) {
                path2.push(['M', cfg.points[i].x, cfg.points[i].y])
            } else {
                path2.push(['L', cfg.points[i].x, cfg.points[i].y])

            }
            if(path3.length==0) {
                path3.push(['M', cfg.points[i].x, cfg.points[i].y])
            } else {
                path3.push(['L', cfg.points[i].x, cfg.points[i].y])
            }
        } 
        if(cfg.points[i]._origin.dt > yesterday) {
            if(cfg.points[i]._origin.mark && cfg.points[i]._origin.is_predict===true) {
                let pre = 'L'
                if(path3.length==0) {
                    pre = 'M'
                }
                path3.push([pre, cfg.points[i].x, cfg.points[i].y])
            } else {
                let pre = 'L'
                if(path2.length==0) {
                    pre = 'M'
                }
                path2.push([pre, cfg.points[i].x, cfg.points[i].y])
            }
        }
        if(cfg.points[i]._origin.dt <= yesterday) {
            let pre = 'L'
            if(path1.length==0) {
                pre = 'M'
            }
            path1.push([pre, cfg.points[i].x, cfg.points[i].y])
        }
    }
    if(path1.length>1) {
        container.addShape('path', {
            attrs: {
            path: path1,
            stroke: color,
            lineWidth: 2
            }
        });
    }
    if(path2.length>1) {
        container.addShape('path', {
            attrs: {
                path: path2,
                stroke: color,
                lineWidth: 2,
                lineDash: [5, 2],
                opacity: 0.7
            }
        });
    }
    if(path3.length>1) {
        container.addShape('path', {
            attrs: {
                path: path3,
                stroke: color,
                lineWidth: 2,
                lineDash: [3, 2],
                opacity: 0.6
            }
        });
    }
    return container;
  }
})


registerShape('point', 'versionPoint', {
  draw(cfg, container) {
    var data = cfg.origin._origin;
    var point = {
      x: cfg.x,
      y: cfg.y,
      color: cfg.color,
    };
    if(data.series_visible===false) {
        return
    }
    if (data.is_version_day  || data.is_predict === true) {
        let content = ""
        if(data.is_predict)
            content = "预"
        if(data.is_version_day) 
            content = "版"
        var littleCircle = container.addShape('circle', {
            attrs: {
            x: point.x,
            y: point.y,
            r: data.is_version_day===2?11:9,
            fill: data.is_version_day===2?'#fff':point.color,
            opacity: data.is_version_day===2?0.9:0.7,
            stroke: point.color,
            lineWidth:data.is_version_day===2?2:0,
            },
        });
        var littleText = container.addShape('text', {
            attrs: {
                fontSize:12,
                text: content,
                textAlign: 'center',
                textBaseline: 'middle',
                fill: data.is_version_day===2?point.color:'#fff',
                x: point.x,
                y: point.y+1,
            },
        });
        littleCircle.on('mouseenter', function(evt) {
            littleCircle.animate({
            r: data.is_version_day===2?12:10,
            stroke:data.is_version_day===2?point.color:'#fff',
            lineWidth:2,
            shadowBlur:8,
            shadowColor:point.color,
            repeat: false,
            opacity:1,
            }, 100);
        });
        littleCircle.on('mouseleave', function(evt) {
            littleCircle.animate({
            r: data.is_version_day===2?11:9,
            lineWidth:data.is_version_day===2?2:0,
            stroke:data.is_version_day===2?point.color:'#fff',
            shadowBlur:0,
            shadowColor:point.color,
            repeat: false,
            opacity: data.is_version_day===2?0.9:0.7,
            }, 100);
        });
        littleText.on('mouseenter', function(evt) {
            littleCircle.animate({
            r: data.is_version_day===2?12:10,
            stroke:data.is_version_day===2?point.color:'#fff',
            lineWidth:2,
            shadowBlur:8,
            shadowColor:point.color,
            repeat: false,
            opacity:1,
            }, 100);
        });
        littleText.on('mouseleave', function(evt) {
            littleCircle.animate({
            r: data.is_version_day===2?11:9,
            lineWidth:data.is_version_day===2?2:0,
            stroke:data.is_version_day===2?point.color:'#fff',
            shadowBlur:0,
            shadowColor:point.color,
            repeat: false,
            opacity: data.is_version_day===2?0.9:0.7,
            }, 100);
        });
    }
    else {
        var littleCircle = container.addShape('circle', {
            attrs: {
                x: point.x,
                y: point.y,
                r: 4,
                fill: point.color,
                opacity: 1
            }
        });
        littleCircle.on('mouseenter', function(evt) {
            littleCircle.animate({
            stroke:'#fff',
            lineWidth:2,
            shadowBlur:8,
            shadowColor:point.color,
            repeat: false,
            }, 100);
        });
        littleCircle.on('mouseleave', function(evt) {
            littleCircle.animate({
            lineWidth:0,
            shadowBlur:0,
            repeat: false,
            }, 100);
        });
    }
  }
})


export default {
    props:{
        conf: {type:Object, default:()=> {}},
        fields: {type:Array, default:()=> {}},
        datas: {type:Array, default:() => []},
        height: {type:Number, default:500},
        marks: {type:Array, default:() => []},
        delay: {type:Number, default:0},
    },
    components: {
        Violin,
    },
    watch:{
        conf() {
            this.filter = undefined;
        },
        datas() {
            this.slider.start = null
            this.slider.end = null
            this.sorter = 'default-sorter'
        },
        marker_guides(newV, oldV) {
            if(newV.length==0 && oldV.length==0) {
                return
            }
            this.change = true
            this.$nextTick(()=>{
                this.change = false
            })
        },
        xLength(newV, oldV) {
            if(oldV==1) {
                this.change = true
                this.$nextTick(()=>{
                    this.change = false
                })
            }
        },
    },
    computed: {
        chart() {
            // if(this.conf.color && this.conf.color.length>0) {
            //     Global.registerTheme('custom', {
            //         colors:this.conf.color,
            //         defaultColor:this.conf.color[0]
            //     });
            //     G2.Global.setTheme('custom');
            // }
            if(this.delay) {
                this.waiting = true
                setTimeout(()=>{this.waiting=false}, this.delay)
            }
            this.change = true
            this.$nextTick(()=>{
                this.change = false
            })

            if(this.conf.type=='violin') {
                return {}
            }

            // 用于版本日标记
            if(this.conf.versionday) {
                let version_days = {}
                if(this.$store.state.game.info && this.$store.state.game.info.new_version_days) {
                    version_days = this.$store.state.game.info.new_version_days
                }
                this.datas.forEach((d)=>{
                    let dt = d[this.conf.versionday]
                    if(version_days[dt]!=null) {
                        d['is_version_day'] = version_days[dt]+1
                    }
                })
            }

            let datas = initData(this.conf, this.datas, this.fields, this.conf.series && this.conf.series.sort?this.sorter:undefined)

            // 混合图颜色
            if (this.conf.type == 'mixin' && this.conf.yaxis && this.conf.y && this.conf.y instanceof Array) {
                if((this.conf.yaxis.left && this.conf.yaxis.left.color) || (this.conf.yaxis.right && this.conf.yaxis.right.color)) {
                    // 正负态颜色
                    let udyaxis = this.conf.yaxis
                    if((udyaxis.left && udyaxis.left.series_type === 'updown') || (udyaxis.right && udyaxis.right.series_type === 'updown')) {
                        initUdColor(this.conf, this.datas)
                    }
                }
                else {
                    let colors = initColor(this.conf.y, this.conf.color)
                    if(this.conf.yaxis.left) {
                        this.conf.yaxis.left.color = colors[0]
                    }
                    if(this.conf.yaxis.right) {
                        this.conf.yaxis.right.color = colors[1]
                    }
                }
            }
            let width = null;
            let height = this.height-30;
            let empty = datas.length<=0;
            if(this.conf.type=='heatmap' || this.conf.type=='polygon') {
                width = this.conf.width;
                height = this.conf.height?this.conf.height:this.height-30;
            }
            if(this.conf.type=='pie') {
                height = this.height;
                empty = datas.length<=0 || datas[0].piechart_empty;
            }
            if(this.conf.type=='cloud') {
                width = 1000;
                height = 600;
            }
            const resConfig = {
                width,
                height,
                type: initType(this.conf),
                scale: initScale(this.conf, this.datas, this.fields, [this.slider.start, this.slider.end]),
                axis: initAxis(this.conf, this.fields, this.datas),
                data: ['worldmap', 'chinamap', 'cloud', 'treemap'].indexOf(this.conf.type)>=0?this.getData(this.conf, this.datas):datas,
                tooltip: initTooltip(this.conf, this.fields),
                label: initLabel(this.conf, this.fields),
                filter: initFilter(this.conf, this.fields, this.filter),
                empty,
            }
            // console.log('TODO: tmpConfig: ', resConfig, this.conf);
            return resConfig;
        },
        series() {
            if(this.conf.type=='mixin') {
                const _series = []
                this.chart.data[0].forEach(row=> {_series.push(row.series)});
                this.chart.data[1].forEach(row=> {_series.push(row.series)});
                return _.uniq(_series)
            }
            if(this.conf.series && this.conf.series.id) {
                return _.uniq(_.map(this.chart.data, this.conf.series.id))
            }
            return []
        },
        series_options() {
            const _series = []
            this.series.forEach(s=>{
                _series.push({label:`${s}(顺序)`, key:`${s}-asc`})
                _series.push({label:`${s}(倒序)`, key:`${s}-desc`})
            })
            return _series
        },
        legend_click() {
            if(this.conf.type=='mixin' && this.conf.yaxis) {
                if(this.conf.yaxis.left && this.conf.yaxis.left.series_type=='updown') {
                    return false
                }
                if(this.conf.yaxis.right && this.conf.yaxis.right.series_type=='updown') {
                    return false
                }
            } else {
                return true
            }
            return true
        },
        marker_guides() {
            //return []

            if(['pie', 'pyramid', 'box', 'candle', 'heatmap', 'worldmap', 'chinamap', 'cloud', 'violin'].indexOf(this.conf.type)>=0) {
                return []
            }
            let min_x, max_x
            if(this.conf.type=='mixin') {
                let xs = []
                xs = _.uniq(_.concat(_.map(this.data[0], 'x'), _.map(this.data[1], 'x')))
                return this.generateMarks(xs, _.min(xs), _.max(xs), 'ds')
            }
            else if(this.conf.x && this.conf.x.id && this.conf.mark) {
                if(this.conf.x.id === 'ds') {
                    let ds_xs = []
                    ds_xs = _.map(_.uniq(_.map(this.data, this.conf.x.id)), x => x)
                    return this.generateMarks(ds_xs, 'ds')
                }
                else if(this.conf.x.id === 'time') {
                    let today = moment().format('YYYY-MM-DD')
                    let time_xs = []
                    time_xs = _.map(_.uniq(_.map(this.data, this.conf.x.id)), x => today+' '+x)
                    return this.generateMarks(time_xs, 'time')
                }
            }
            return []
            // if(xs.length <= 0) {
            //     return []
            // }
            // if(!this.isDate(xs[0])) {
            //     return []
            // }
            // // 获取标注
            // let markers = _.cloneDeep(this.marks)
            // let marker_guides = []
            // let min_x = _.min(xs), max_x = _.max(xs)
            // if(markers.length > 0) {
            //     markers.forEach((marker)=>{
            //         marker.start_dt = moment(marker.start_dt).format('YYYY-MM-DD HH:mm:ss')
            //         marker.end_dt = moment(marker.end_dt).format('YYYY-MM-DD HH:mm:ss')
            //         // 如果标注日期范围不在x轴范围内
            //         if(marker.start_dt>max_x || marker.end_dt<min_x) {
            //             return
            //         }
            //         // 如果标注日期范围大于x轴范围则进行调整
            //         let start_before = false, end_after = false
            //         if(marker.start_dt < min_x) {
            //             marker.start_dt = min_x
            //             start_before = true
            //         }
            //         if(marker.end_dt > max_x) {
            //             marker.end_dt = max_x
            //             end_after = true
            //         }
            //         let start_pos = null, end_pos = null
            //         let guide_type = 'line'
            //         if(marker.start_dt == marker.end_dt) {
            //             // 如果为单点的情况
            //             start_pos = end_pos = xs.indexOf(marker.start_dt)
            //         }
            //         else {
            //             // 如果为多点的情况
            //             guide_type = 'region'
            //             start_pos = xs.indexOf(marker.start_dt)
            //             start_pos= start_pos==0 && start_before?-0.5:start_pos
            //             end_pos = xs.indexOf(marker.end_dt)
            //             end_pos = end_pos==xs.length-1 && end_after?end_pos+0.5:end_pos
            //         }
            //         if(start_pos>end_pos) {
            //             let tmp_pos = start_pos
            //             start_pos = end_pos
            //             end_pos = tmp_pos
            //         }
            //         let mark = {
            //             type: guide_type,
            //             start: [start_pos, 'min'],
            //             end: [end_pos, 'max'],
            //         }
            //         if(guide_type=='region') {
            //             mark.vStyle = { fill:'#7190FF', fillOpacity: 0.1}
            //         }
            //         else {
            //             mark.lineStyle = { stroke:'#7190FF', strokeOpacity: 0.45}
            //         }
            //         // 标注区域
            //         marker_guides.push(mark)
            //         // 标注文字
            //         marker_guides.push({
            //             type: 'html',
            //             position: [(start_pos + end_pos) / 2.0 , 'max'],
            //             html: `<div class='chart_custom_marker' ref="marker" title='${marker.tooltip?marker.tooltip:marker.text}'><span>${marker.text}</span></div>`
            //         })
            //     })
            // }
            // return marker_guides
        },
        
        guides() {
            const _conf = {
                x: this.conf.type === 'mixin' ? 'x' : (this.conf.x && this.conf.x.id ? this.conf.x.id : null),
                y: this.conf.type === 'mixin' ? 'y' : (this.conf.y && this.conf.y.id ? this.conf.y.id : null),
                series: this.conf.type === 'mixin' ? 'series' : (this.conf.series && this.conf.series.id ? this.conf.series.id : null)
            }

            let guides = []
            if(this.conf.online && ['area', 'line', 'spline'].indexOf(this.conf.type)>=0 && (this.conf.y && this.conf.y.id)) {
                let ys = _.map(this.datas, this.conf.y.id)
                let maxy = _.max(ys)
                let maxy_index = ys.indexOf(maxy)
                if(maxy_index >= 0) {
                    let item = this.datas[maxy_index]
                    guides = [{x:maxy_index, y:maxy, type:'text', text:`${item[this.conf.x.id]}\n达到最高值:${maxy}`}]
                }
            }
            
            if(this.conf.guide && (_conf.y && _conf.x)) {
                // 最大值标注、最小
                if(this.conf.guide.max || this.conf.guide.min) {
                    const compares = []
                    const lengths = {max:3, min:3}
                    if (this.conf.guide.max) {
                        compares.push('max')
                        if (this.conf.guide.max!==true) {
                            lengths.max = this.conf.guide.max
                        }
                    }
                    if (this.conf.guide.min) {
                        compares.push('min')
                        if (this.conf.guide.min!==true) {
                            lengths.min = this.conf.guide.min
                        }
                    }

                    const values = {
                        max: [],
                        min: [],
                    }
                    let xs = []

                    // 取出每日最大最小值
                    this.datas.forEach(row=>{
                        if(row[_conf.y]) {
                            if(!(row[_conf.x] in xs)) {
                                xs[row[_conf.x]] = {max:row[_conf.y], min:row[_conf.y]}
                            }
                            else if(row[_conf.y] > xs[row[_conf.x]].max) {
                                xs[row[_conf.x]].max = row[_conf.y]
                            }
                            else if(row[_conf.y] < xs[row[_conf.x]].min) {
                                xs[row[_conf.x]].min = row[_conf.y]
                            }
                        }
                    })
                    // 取出最大最小日
                    Object.keys(xs).forEach((x)=>{
                        const row = {x, ...xs[x]}
                        compares.forEach(type=>{
                            const list = values[type]
                            if(list.length < lengths[type]) {
                                list.push(row)
                            }
                            else if(type==='min'? row[type] < list[list.length - 1][type] : row[type] > list[list.length - 1][type]) {
                                for(let m_i=0; m_i < list.length; m_i++) {
                                    if(type==='min' ? row[type] < list[m_i][type] : row[type] > list[m_i][type]) {
                                        list.splice(m_i, 0, row)
                                        list.pop()
                                        break;
                                    }
                                }
                            }
                        })
                    })
                    compares.forEach(type=>{
                        const list = values[type]
                        list.forEach((row, index)=>{
                            guides.push({
                                x: row.x, 
                                y: row[type], 
                                type:'dataMarker', 
                                content: `${row[type].toLocaleString()}${this.conf.y.suffix?this.conf.y.suffix:''}`,
                                direction: type === 'min'? 'downward' : 'upward',
                                style: {
                                    text: {
                                        textAlign: index % 2 ? 'right' : 'left',
                                    },
                                    point: {
                                        stroke: '#999',
                                    }
                                }
                            })
                        })
                    })
                }

                if(this.conf.guide.week_peak) {
                    const weekday_id = this.conf.weekday === true ? 'ds' : this.conf.weekday
                    let ys = []
                    let current_peak = null
                    this.datas.forEach((row, index)=>{
                        if(moment(row[weekday_id]).weekday() === 0 && current_peak) {
                            if(current_peak.y) {
                                ys.push(current_peak)
                            }
                            current_peak = null
                        }

                        if( !current_peak || row[_conf.y] > current_peak.y) {
                            current_peak = {index, x:row[_conf.x], y:row[_conf.y]}
                        }
                    })
                    if(current_peak && current_peak.y) {
                        ys.push(current_peak)
                    }

                    if(ys.length >= 0) {
                        ys.forEach(row=>{
                            guides.push({x:row.x, y: row.y, type:'dataMarker', content:`${row.y.toLocaleString()}`})
                        })
                    }
                }
            }
            
            const _Sat = this.$t('week.short_6')
            const _Sun = this.$t('week.short_7')
            if(this.conf.weekday) {
                const weekday_id = this.conf.weekday === true ? 'ds' : this.conf.weekday
                let xs = {}
                let weekday_guides = []
                this.data.forEach((d)=>{
                    if(!xs[d[this.conf.x.id]]) {
                        const weekday_val = this.$t(`week.short_${moment(d[weekday_id]).weekday()+1}`)
                        weekday_guides.push({x:d[this.conf.x.id], y:0, type:'html', html:`<div class='chart_label_day ${weekday_val==_Sat || weekday_val==_Sun?'weekend':''}'>${weekday_val}</div>`})
                        xs[d[this.conf.x.id]] = 1
                    }
                })
                if(weekday_guides.length < 62) {
                    guides = [...guides, ...weekday_guides]
                }
            }
            if(this.conf.fixed && this.conf.x.id=='ds') {
                let xs = {}
                this.data.forEach((d)=>{
                    if(!xs[d[this.conf.x.id]]) {
                        guides.push({x:d[this.conf.x.id], y:0, type:'html', html:`<div class='chart_label_day ${d.weekday==_Sat || d.weekday==_Sun?'weekend':''}'>${d.weekday}</div>`})
                        xs[d[this.conf.x.id]] = 1
                    }
                })
                if (guides.length>62) {
                    this.change = true
                    this.conf.point = false
                    this.$nextTick(()=>{
                        this.change = false
                    })
                    guides.forEach((g)=>{
                        g['html'] = '<div></div>'
                    })
                }
                else if(this.conf.point===false) {
                    this.conf.point = true
                    this.change = true
                    this.$nextTick(()=>{
                        this.change = false
                    })
                }
            }
            if(this.conf.fixed && this.conf.x.id=='weekname') {
                let month_guides = [{'week':'第1周', 'month':'1月'}]
                let year = _.max(_.map(this.datas, 'year'))
                for(let month=2; month<=12; month++) {
                    let day = moment(`${year}-${month<=9?`0${month}`:month}-01`)
                    month_guides.push({'week':`第${day.week()}周`, 'month':`${month}月`})
                }
                month_guides.forEach((month)=>{
                    let week_index = this.sliderX.indexOf(month.week)
                    if(week_index>=0) {
                        guides.push({x:month.week, y:0, type:'html', html:`<div class='chart_label_month'>${month.month}</div>`})
                    }
                })
            }
            this.change = true
            this.$nextTick(()=>{
                this.change = false
            })
            return guides
        },
        data() {
            let datas = this.chart.data
            if(this.slider.start && this.slider.end) {
                let startIndex = this.allX.indexOf(this.slider.start)
                let endIndex = this.allX.indexOf(this.slider.end)
                if(this.conf.type=='mixin') {
                    datas = [_.filter(datas[0], (row)=>this.allX.indexOf(row['x'])>=startIndex && this.allX.indexOf(row['x'])<=endIndex), _.filter(datas[1], (row)=>this.allX.indexOf(row['x'])>=startIndex && this.allX.indexOf(row['x'])<=endIndex)]
                } else {
                    datas = _.filter(datas, (row)=>this.allX.indexOf(row[this.conf.x.id])>=startIndex && this.allX.indexOf(row[this.conf.x.id])<=endIndex)
                }
            }
            return datas
        },
        worldGeoData() {
            if(this.conf.type == 'worldmap') {
                const DataSet = require('@antv/data-set');
                const worldDV = new DataSet.View().source(require('@/utils/worldGeo.json'), {type: 'GeoJSON'});
                if (this.$i18n.locale === 'en_US') {
                    return worldDV;
                } else {
                    return worldDV.transform({
                        type: 'map',
                        callback(row) {
                            row.name = row.name && worldNamesDict.en2cn[row.name] ? worldNamesDict.en2cn[row.name] : row.name;
                            return row;
                        },
                    });
                }
            }
            return []
        },
        chinaGeoData() {
            if(this.conf.type == 'chinamap') {
                const DataSet = require('@antv/data-set');
                const chinaDV =  new DataSet.View().source(require('@/utils/chinaGeo.json'), {type: 'GeoJSON'});
                if (this.$i18n.locale === 'en_US') {
                    return chinaDV.transform({
                        type: 'map',
                        callback(row) {
                            row.name = row.name && ChinaCityLang[row.name] ? ChinaCityLang[row.name] : row.name;
                            return row;
                        },
                    });
                } else {
                    return chinaDV
                }
            }
            return []
        },
        allX() {
            if(!this.conf) {
                return []
            }
            if(this.conf.type=='mixin') {
                return _.uniq(_.concat(_.map(this.chart.data[0], 'x'), _.map(this.chart.data[1], 'x')))
            }
            else if(this.conf.x && this.conf.x.id) {
                return _.uniq(_.map(this.chart.data, this.conf.x.id))
            }
            return []
        },
        sliderX() {
            if(!this.conf) {
                return []
            }
            if(this.conf.type=='mixin') {
                return _.uniq(_.concat(_.map(this.data[0], 'x'), _.map(this.data[1], 'x')))
            }
            else if(this.conf.x && this.conf.x.id) {
                return _.uniq(_.map(this.data, this.conf.x.id))
            }
            return []
        },
        xLength() {
            return this.sliderX.length
        },
        mixinY() {
            let l_type = 'bar', r_type = 'line', l_color=[], r_color=[]
            if(this.conf.yaxis && this.conf.yaxis.left) {
                if (this.conf.yaxis.left.type) {
                    l_type = this.conf.yaxis.left.type
                }
                if (this.conf.yaxis.left.color) {
                    l_color = this.conf.yaxis.left.color
                }
            }
            if(this.conf.yaxis && this.conf.yaxis.right) {
                if (this.conf.yaxis.right.type) {
                    r_type = this.conf.yaxis.right.type
                }
                if (this.conf.yaxis.right.color) {
                    r_color = this.conf.yaxis.right.color
                }
            }
            let l = _.uniq(_.map(this.data[0], 'series'))
            let r = _.uniq(_.map(this.data[1], 'series'))
            let ys = {}
            l.forEach((y, index) => {
                ys[y] = {type:l_type}
                if(index < l_color.length) {
                    ys[y].color = l_color[index]
                }
            })
            r.forEach((y,index) => {
                ys[y] = {type:r_type}
                if(index < r_color.length) {
                    ys[y].color = r_color[index]
                }
            })
            return ys
        }
    },
    data() {
        return {
            uuid:"",
            change: false,
            slider: {
                padding:[20, 200, 20, 200],
                start: null,
                end: null,
            },
            heatmap: {
                point: true,
                heat: true,
            },
            filter: undefined,
            legendNum:0,
            waiting: false,
            sorter: 'default-sorter',
        }
    },
    created() {
        this.uuid = this.guid()
    },
    mounted() {
        if (this.conf && this.conf.htmllegend) {
            let setupAttempts = 0
            const setup = () => {
                setupAttempts++
                const container = document.getElementById(`chart_legend_${this.uuid}`)
                if (!container) {
                    if (setupAttempts < 10) {
                        setTimeout(setup, 200)
                    }
                    return
                }
                // 拦截 appendChild：G2 _renderHTML 追加新 .g2-legend 前自动清理旧的
                if (container._patchedAppendChild) return
                container._patchedAppendChild = true
                const _appendChild = container.appendChild.bind(container)
                container.appendChild = function(node) {
                    if (node.nodeType === 1 && node.classList.contains('g2-legend')) {
                        const wrappers = container.querySelectorAll('.g2-legend')
                        for (let i = wrappers.length - 1; i >= 0; i--) {
                            wrappers[i].remove()
                        }
                    }
                    return _appendChild(node)
                }
            }
            setTimeout(setup, 200)
        }
    },
    beforeDestroy() {
    },
    methods: {
        generateMarks(xs, type) {
            if(xs.length <= 0) {
                return []
            }
            if(!isDate(xs[0]) && type=='time') {
                return []
            }
            if(!isDate(xs[0], false) && type=='ds') {
                return []
            }
            // 获取标注
            let min_x = _.min(xs), max_x = _.max(xs)
            let markers = _.cloneDeep(this.marks)
            let marker_guides = []
            if(markers.length > 0) {
                markers.forEach((marker)=>{
                    if(type=='time') {
                        marker.start_dt = moment(marker.start_dt).format('YYYY-MM-DD HH:mm:ss')
                        marker.end_dt = moment(marker.end_dt).format('YYYY-MM-DD HH:mm:ss')
                    } else {
                        marker.start_dt = moment(marker.start_dt).format('YYYY-MM-DD')
                        marker.end_dt = moment(marker.end_dt).format('YYYY-MM-DD')
                    }
                    // 如果标注日期范围不在x轴范围内
                    if(marker.start_dt>max_x || marker.end_dt<min_x) {
                        return
                    }
                    // 如果标注日期范围大于x轴范围则进行调整
                    let start_before = false, end_after = false
                    if(marker.start_dt < min_x) {
                        marker.start_dt = min_x
                        start_before = true
                    }
                    if(marker.end_dt > max_x) {
                        marker.end_dt = max_x
                        end_after = true
                    }
                    // start_pos、end_pos、text_pos 可以为相对number或者坐标
                    let start_pos = null, end_pos = null, text_pos = null;
                    let guide_type = 'line';
                    if(marker.start_dt == marker.end_dt) {
                        // 如果为单点的情况
                        start_pos = end_pos = text_pos = marker.start_dt;
                        // start_pos = end_pos = xs.indexOf(marker.start_dt)
                    }
                    else {
                        // 如果为多点的情况
                        guide_type = 'region'
                        start_pos = xs.indexOf(marker.start_dt)
                        start_pos= start_pos==0 && start_before?-0.5:start_pos
                        end_pos = xs.indexOf(marker.end_dt)
                        end_pos = end_pos==xs.length-1 && end_after?end_pos+0.5:end_pos
                        if(start_pos>end_pos) {
                            let tmp_pos = start_pos
                            start_pos = end_pos
                            end_pos = tmp_pos
                        }
                        text_pos = (start_pos + end_pos) / 2.0;
                    }
                    let mark = {
                        type: guide_type,
                        start: [start_pos, 'min'],
                        end: [end_pos, 'max'],
                    }
                    if(guide_type=='region') {
                        mark.vStyle = { fill:'#7190FF', fillOpacity: 0.1}
                    }
                    else {
                        mark.lineStyle = { stroke:'#7190FF', strokeOpacity: 0.45}
                    }
                    // 标注区域
                    marker_guides.push(mark)
                    // 标注文字
                    if (marker.text) {
                        marker_guides.push({
                            type: 'html',
                            position: [text_pos, 'max'],
                            html: `<div class='chart_custom_marker' ref="marker" title='${marker.tooltip?marker.tooltip:marker.text}'><span>${marker.text}</span></div>`
                        })                        
                    }
                    if (marker.text2) {
                        marker_guides.push({
                            type: 'html',
                            position: [text_pos, 'max'],
                            html: `<div class='chart_custom_marker2' title='${marker.text2}'><span>${marker.text2}</span></div>`
                        })  
                    }
                })
            }
            return marker_guides
        },
        guid() {
            return 'xxxxxxxx-xxxx-4xxx-yxxx-xxxxxxxxxxxx'.replace(/[xy]/g, function (c) {
                var r = Math.random() * 16 | 0,
                    v = c == 'x' ? r : (r & 0x3 | 0x8);
                return v.toString(16);
            })
        },
        changeSlider(_ref) {
            let startIndex = this.allX.indexOf(_ref.startText)
            let endIndex = this.allX.indexOf(_ref.endText)
            if(startIndex>endIndex) {
                this.slider.start = _ref.startText
                this.slider.end = _ref.startText
            }
            else {
                this.slider.start = _ref.startText
                this.slider.end = _ref.endText
            }
        },
        changeHeatmap(e, type) {
            if(type=='point') {
                this.heatmap.point = e.target.checked
            } 
            else {
                this.heatmap.heat = e.target.checked
            }
            this.change = true
            this.$nextTick(()=>{
                this.change = false
            })
        },
        getData(conf, datas) {
            if(conf.type == 'worldmap' || conf.type == 'chinamap') {
                return this.getMapData(conf, datas)
            }
            if(conf.type == 'cloud') {
                return this.getCloudData(conf, datas)
            }
            if(conf.type == 'treemap') {
                return this.getTreemapData(conf, datas)
            }
            return []
        },
        getMapData(conf, datas){
            datas.forEach((row)=>{
                row['ename'] = row['name']
            })

            let mapData = []
            if(conf.type=='chinamap') {
                mapData = this.chinaGeoData
            }
            if(conf.type=='worldmap') {
                mapData = this.worldGeoData
            }
            const DataSet = require('@antv/data-set');
            const dv = new DataSet.View().source(datas).transform({
                geoDataView: mapData,
                field: 'ename',
                type: 'geo.region',
                as: ['longitude', 'latitude'],
            })
            return dv.rows
        },
        getCloudData(conf, datas) {
            if(!datas || datas.length<=0) {
                return []
            }
            const DataSet = require('@antv/data-set');
            const dv = new DataSet.View().source(datas);
            const range = dv.range(conf.y.id);
            const min = range[0];
            const max = range[1];
            dv.transform({
                type: 'tag-cloud',
                fields: [conf.x.id, conf.y.id],
                size: [1000, 600],
                padding: 0,
                timeInterval: 5000, // max execute time
                rotate() {
                    let random = ~~(Math.random() * 4) % 4;
                    if (random == 2) {
                        random = 0;
                    }
                    return random * 90; // 0, 90, 270
                },
                fontSize(d) {
                    if (d[conf.y.id]) {
                        return ((d[conf.y.id] - min) / (max - min)) * (50 - 12.5) + 12.5;
                    }
                    return 0;
                }
            });
            return dv.rows
        },
        getTreemapData(conf, datas) {
            let newdatas = {name: 'root', children: []}
            if(datas) {
                datas.forEach((row)=>{
                    newdatas.children.push({'name':`${row[conf.x.id]}`, 'value':row[conf.y.id]})
                })
                newdatas.children = _.orderBy(newdatas.children, ['value'], ['desc']).slice(0, 50)
            }
            const DataSet = require('@antv/data-set');
            const dv = new DataSet.View().source(newdatas, {type: 'hierarchy',})
            dv.transform({
                field: 'value',
                type: 'hierarchy.treemap',
                tile: 'treemapResquarify',
                as: ['x', 'y'],
            });
            const trans_datas = dv.getAllNodes().map((node) => ({
                ...node,
                name: node.data.name,
                value: node.data.value,
            }));
            return trans_datas
        },
        // isDate(dateString){
        //     var r=dateString.toString().match(/^(\d{1,4})(-)(\d{1,2})\2(\d{1,2})\s+(20|21|22|23|[0-1]\d):[0-5]\d:[0-5]\d$/); 
        //     if(r==null) {
        //         return false;
        //     }
        //     var d=new Date(r[1],r[3]-1,r[4]);  
        //     var num = (d.getFullYear()==r[1]&&(d.getMonth()+1)==r[3]&&d.getDate()==r[4]);
        //     if(num==0){
        //         return false
        //     }
        //     return true;
        // },
        legendTemplate(value, color, checked, index) {
            let ncolor = color, ntype = this.conf.type
            if(this.conf.type=='mixin') {
                if(this.mixinY[value].color)
                    ncolor = this.mixinY[value].color
                if(this.mixinY[value].type)
                    ntype = this.mixinY[value].type
            }
            checked = checked ? 'checked' : 'unChecked';
            return `<li class="g2-legend-list-item item-${index} ${checked}" data-color="{originColor}" data-value="${value}" style="cursor: pointer;font-size: 14px;"><div class="g2-legend-marker-container"><i class="g2-legend-marker"></i></div><i class="g2-custom-marker g2-${ntype}-marker checked" style="background-color: {originColor};"></i><i class="g2-custom-marker g2-${ntype}-marker unChecked" style="background-color: #bfbfbf;"></i><span class="g2-legend-text">${value}</span></li>`
        },
        handleLegend(close) {
            if(close) {
                this.filter = []
            }
            else {
                this.filter = this.series;
            }
        },
        sorter_change(v) {
            if(!v || v=='default-sorter') {
                this.filter = undefined
            }
            else {
                this.filter=[v.substring(0, v.lastIndexOf('-'))]
            }
        },
        // summary_tooltip_sort: tooltip 条目按当前纵轴 y 值降序展示
        // G2 v3 共享 tooltip 条目顺序 = series 全局首现顺序(冻结), 数据重排无法逐 x 生效,
        // 只能在此事件回调中对 items 原地重排(item.point._origin 为原始数据行)
        // 注意: 事件回调与 G2 渲染 setContent 共用同一 items 数组引用, sort 原地修改即生效
        handleTooltipChange(ev) {
            if(this.conf.summary_tooltip_sort !== true || !this.conf.series || !ev.items) {
                return
            }
            const yField = this.conf.y && this.conf.y.id
            if(!yField) {
                return
            }
            ev.items.sort((a, b)=>{
                const va = a.point && a.point._origin ? Number(a.point._origin[yField]) : NaN
                const vb = b.point && b.point._origin ? Number(b.point._origin[yField]) : NaN
                const aInvalid = !isFinite(va)
                const bInvalid = !isFinite(vb)
                if(aInvalid && bInvalid) return 0
                if(aInvalid) return 1
                if(bInvalid) return -1
                return vb - va
            })
        }
    }
}
</script>
<style lang="less">
#chart_legend_control {
    position: absolute;
    top: -18px;
    right: 0px;
    height: 30px;
    .ant-btn {
        font-size: 12px;
        margin: 0 0 0 10px;
    }
}
#chart_legend {
    .g2-legend-text {
        font-size:12px;
    }
}
.chart_legend {
    text-align: center;
    .g2-legend {
        display: inline-block;
        max-height: 100px;
        overflow: auto;
        &::-webkit-scrollbar  
        {  
            width: 5px;  /*滚动条宽度*/
            height: 5px;  /*滚动条高度*/
            background:#f6f6f6;
        } 

        /*定义滑块 内阴影+圆角*/  
        &::-webkit-scrollbar-thumb  
        {  
            border-radius: 3px;  /*滚动条的圆角*/
            background-color: #ddd;  /*滚动条的背景颜色*/
        }  
    }
    .g2-legend-text {
        font-size:12px;
    }
    .g2-legend-marker-container {
        display: none;
    }
    .g2-custom-marker {
        width:10px;
        height:10px;
        border-radius:50%;
        display:inline-block;
        margin-right:5px;
    }
    .unChecked .g2-custom-marker.checked {
        display: none
    }
    .checked .g2-custom-marker.unChecked {
        display: none
    }
    .g2-mixin-marker {
        border-radius:0;
    }
    .g2-bar-marker {
        width:8px;
        height:8px;
        margin-top:1px;
        margin-bottom:1px;
        border-radius:0;
    }
    .g2-area-marker {
        height:6px;
        border-radius: 0;
        margin-top:2px;
        margin-bottom:2px;
    }
    .g2-line-marker, .g2-spline-marker {
        height:2px;
        border-radius: 0;
        margin-top:4px;
        margin-bottom:4px;
    }
}

.chart_legend {
    text-align: center;
    &.g2-legend {
        display: inline-block;
    }
    .g2-legend-text {
        font-size:12px;
    }
    .g2-legend-marker-container {
        display: none;
    }
    .g2-custom-marker {
        width:10px;
        height:10px;
        border-radius:50%;
        display:inline-block;
        margin-right:5px;
    }
    .unChecked .g2-custom-marker.checked {
        display: none
    }
    .checked .g2-custom-marker.unChecked {
        display: none
    }
    .g2-mixin-marker {
        border-radius:0;
    }
    .g2-bar-marker {
        width:8px;
        height:8px;
        margin-top:1px;
        margin-bottom:1px;
        border-radius:0;
    }
    .g2-area-marker {
        height:6px;
        border-radius: 0;
        margin-top:2px;
        margin-bottom:2px;
    }
    .g2-line-marker, .g2-spline-marker {
        height:2px;
        border-radius: 0;
        margin-top:4px;
        margin-bottom:4px;
    }
}

.chart_guide {
    background:rgba(255,255,255, 0.6);
    border:1px solid rgba(24,124,255,0.3);
    border-radius: 3px;
    padding:5px 10px;
}
.chart_custom_marker {
    background:rgba(113, 144, 255, 0.5);
    border-radius: 5px;
    margin:-15px 0 0 0;
    font-size: 12px;
    color:#fff;
    height:16px;
    line-height: 16px;
    text-align: center;
    overflow: hidden;
    span {
        display: inline-block;
        margin: 0 6px;
        max-width: 160px;
        text-overflow: ellipsis;
        white-space: nowrap;
        overflow: hidden;
    }
    &:after {
        position:absolute;
        bottom:0;
        left:50%;
        margin:0 0 -7px -5px;
        content:"";
        border-right:5px solid transparent;
        border-left:5px solid transparent;
        border-top:7px solid rgba(113, 144, 255, 0.5);
    }
}
.chart_custom_marker2 {
    color: rgba(255,0,0, 0.6);
    font-size: 12px;
    margin: 12px 0 0 0;
    max-width: 96px;
    text-align: center;
}
.chart_trans_select {
    font-size: 12px;
}
</style>